import type {
  MissingCounterpartyInitialBalanceAlert,
} from '@fsd/entities/global-alert';
import { routes } from '@fsd/shared/config/routes/routesConfig'

import { NavLink } from 'react-router-dom';

interface Props {
  alert: MissingCounterpartyInitialBalanceAlert;
}

export const MissingCounterpartyBalanceAlert = ({ alert }: Props) => {
  return (
    <>
      Внимание! Не заполнены начальные остатки контрагентов. Количество
      незаполненных записей: {alert.incomplete_count}. Организаций:{' '}
      {alert.organisations_count}.{' '}
      <NavLink
        to={routes.counterparties.path}
        style={{ textDecoration: 'underline' }}
      >
        Перейти в раздел для исправления
      </NavLink>
    </>
  );
};